export const MSG_RESET = "MSG_RESET";
export const MSG_LIVE_STARTED = "MSG_LIVE_STARTED";
export const MSG_LIVE_SNAPSHOT = "MSG_LIVE_SNAPSHOT";
export const MSG_LIVE_ERROR = "MSG_LIVE_ERROR";
export const MSG_OLDER_REQUEST = "MSG_OLDER_REQUEST";
export const MSG_OLDER_SUCCESS = "MSG_OLDER_SUCCESS";
export const MSG_OLDER_FAILURE = "MSG_OLDER_FAILURE";
export const MSG_SET_HAS_MORE = "MSG_SET_HAS_MORE";
export const MSG_SENDING = "MSG_SENDING";
export const MSG_SENT = "MSG_SENT";
export const MSG_SEND_ERROR = "MSG_SEND_ERROR";

export const MSG_TOGGLE_PIN = "MSG_TOGGLE_PIN";

export const MSG_SET_PINNED_LIST = "MSG_SET_PINNED_LIST";

export const MSG_PENDING_ADD = "MSG_PENDING_ADD";
export const MSG_UPLOAD_PROGRESS = "MSG_UPLOAD_PROGRESS";
export const MSG_UPLOAD_DONE = "MSG_UPLOAD_DONE";
